import { AuthProvider } from './context/AuthContext';
import { AppProvider } from './context/AppContext';
import { CartProvider } from './context/CartContext';
import { ToastProvider } from './context/ToastContext';
import AppRouter from './routes/AppRouter';
import SplashGate from './components/SplashGate';
import FestiveLayer from './components/FestiveLayer';

/**
 * KAAMWALA web portal.
 *
 * Same API, same workflow and same design language as the mobile app - laid out
 * for a browser. The provider order matters: cart reads the session from auth,
 * and every page can raise a toast or a confirm dialog.
 */
const App = () => (
  <ToastProvider>
    <AuthProvider>
      <AppProvider>
        <CartProvider>
          <SplashGate>
            <AppRouter />
          </SplashGate>
          {/* Over everything, takes no clicks: see components/FestiveOverlay. */}
          <FestiveLayer />
        </CartProvider>
      </AppProvider>
    </AuthProvider>
  </ToastProvider>
);

export default App;
